<template>
  <form-wizard ref="trade-wizard" title="New Trade" stepSize="sm"
               noFinishButton v-bind:busy="form.busy"
               @startIndex="onNewIndex"
               validate-on-back lazy
  >
    <!--Personal details step  -->
    <tab-content :title="$t('trade.newTrade')" :before-change="validateTrade">
      <slot name="newTrade"></slot>
    </tab-content>
    <tab-content :title="$t('operations.revision')">
      <slot name="revision"></slot>
    </tab-content>
    <tab-content :title="$t('operations.report')" >
      <slot name="report"></slot>
    </tab-content>


  </form-wizard>
</template>

<script>
import mixinBase from '@/components/mixin/mixinBase'
import mixinNotifications from '@/components/mixin/mixinNotifications'

export default {
  name: 'tradeOrderMassFormPart',
  mixins: [mixinBase, mixinNotifications],
  props: {
    value: {},
    stopPricesValidation: {},
  },
  data: () => ({
    form: {
      busy: false,
    },
  }),
  computed: {
    tradeDetails: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
  },
  methods: {
    onNewIndex(tabIndex){
      if(tabIndex === 2){
        this.form.busy=true;
        this.$emit('generateReport');
      }else {
        this.form.busy=false;
      }
    },
    validateTrade() {
      if (this.tradeDetails.symbolId == null || this.tradeDetails.symbolId === '') {
        this.showErrorNotification('Symbol', 'Symbol is required')
        return false
      }
      if (this.tradeDetails.lots == null || this.tradeDetails.lots === '' || isNaN(this.tradeDetails.lots) || this.tradeDetails.lots <= 0) {
        this.showErrorNotification('Lots must be greater than 0')
        return false
      }
      if (this.tradeDetails.openTime == null || this.tradeDetails.openTime === '') {
        this.showErrorNotification('Open time is required')
        return false
      }
      if (this.tradeDetails.openPrice == null || this.tradeDetails.openPrice === '' || isNaN(this.tradeDetails.openPrice) || this.tradeDetails.openPrice <= 0) {
        this.showErrorNotification('Open price must be greater than 0')
        return false
      }
      if (this.stopPricesValidation.tp === false) {
        this.showErrorNotification('Take profit', 'Take profit must be greater than current price')
        return false
      }
      if (this.stopPricesValidation.sl === false) {
        this.showErrorNotification('Stop loss', 'Stop loss must be less than current price')
        return false
      }
      this.$emit('showGraph', false)
      return true
    },
    setBusy(isBusy) {
      this.form.busy = isBusy
    },
  }
}
</script>

<style scoped>

</style>
